
import consumer from "./consumer"

document.addEventListener("turbo:load", restoreProgress)
document.addEventListener("DOMContentLoaded", restoreProgress)

function restoreProgress() {
  const saved = localStorage.getItem("report_progress_state")
  if (!saved) return

  const { progress, status } = JSON.parse(saved)

  const wrapper = document.getElementById("report-progress-wrapper")
  const bar = document.getElementById("report-progress-bar")

  if (!wrapper || !bar) return

  // wrapper.style.display = "block"
  bar.style.width = `${progress}%`
  bar.textContent = `${progress}%`
}

consumer.subscriptions.create(
  { channel: "ReportsChannel" },
  {
    received(data) {
      const wrapper = document.getElementById("report-progress-wrapper")
      const bar = document.getElementById("report-progress-bar")
      const successBox = document.querySelector(".success_reports")

      // if (data.message && successBox) {
      //   successBox.innerHTML = data.message
      // }
      if (data.message) {
        const downloadLink = document.getElementById("download_link")

        if (downloadLink) {
          const tempDiv = document.createElement("div")
          tempDiv.innerHTML = data.message

          const link = tempDiv.querySelector("a")

          if (link) {
            downloadLink.href = link.href
            downloadLink.innerHTML =
              '<i class="fas fa-cloud-download-alt"></i> Download CSV'
            downloadLink.style.display = "inline-block"
          }
        }
      }

      if (data.progress !== undefined) {
        const state = {
          progress: data.progress,
          status: data.progress >= 100 ? "done" : "running"
        }

        localStorage.setItem("report_progress_state", JSON.stringify(state))

        if (wrapper) wrapper.style.display = "block"
        if (bar) {
          bar.style.width = `${data.progress}%`
          bar.textContent = `${data.progress}%`
        }

        if (data.progress >= 100) {
          setTimeout(() => {
            wrapper.style.display = "none"
            localStorage.removeItem("report_progress_state")
          }, 3000)
        }
      }

      if (data.error) {
        localStorage.removeItem("report_progress_state")
        if (wrapper) wrapper.style.display = "none"
      }
    }
  }
)
